import stepStyles from "./StepInput.module.css";
import styles from "./InputShared.module.css"

const InputWrapper = (props: {mode?: "step" | "settings", pass: boolean, child: JSX.Element}) => {
    return(
        props.mode === "step" ? <div className={props.pass ? styles.password__wrapper : stepStyles.container}>{props.child}</div> : props.child
    );
};

export default InputWrapper